import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import parameterize from '../../utils/parameterize'
import getCrossDomainUrl from '../../utils/getCrossDomainUrl'
import AccountSummary from '../AccountSummary'
import { Cross2Icon, Chevron2Icon } from '../icons'
import LiveCardOverlay from '../LiveCardOverlay'

const PlayerMenu = ({
  id,
  isActive,
  items,
  hostname,
  activeItem,
  user,
  closeMenu,
  groupToken,
  renderCTVBanner,
  isSearchMenuActive,
  closeSearch,
  accountMenuActive,
}) => {
  useEffect(() => {
    if (isSearchMenuActive) setShowLiveTV(false)
    if (accountMenuActive) setShowLiveTV(false)
    if (isActive) setShowLiveTV(false)
  }, [isSearchMenuActive !== false, accountMenuActive, isActive])
  const isActiveItem = (item, url) => (url.split('/').filter(e => e !== '')[0] === item) || (item === '' && url === '/')
  const [showLiveTV, setShowLiveTV] = useState(false)
  const [isDesktop, setIsDesktop] = useState(true)
  const handleLiveTVClick = () => {
    // edge casey, but will update playerApiCache and if clicked at
    // the right time on live page could cause live player to think programme
    // hasn't updated and check every minute for eternity
    setShowLiveTV(!showLiveTV)
  }
  useEffect(() => {
    if (isSearchMenuActive) setShowLiveTV(false)
  }, [isSearchMenuActive])

  useEffect(() => {
    if (showLiveTV) closeSearch()
  }, [showLiveTV])

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1300)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  const makeClassName = (stem, variant) => [stem, variant].reduce((acc, cur) => (
    `${acc} ${acc}--${parameterize(cur)}`
  ))
  return (
    <div className={`PlayerMenu ${isActive ? 'active' : ''} ${user?.signedIn ? 'logged-in' : 'logged-out'}`} data-testid="player-menu">
      <div className="menu-header">
        {user && user.firstName && activeItem === 'account' && !isActive && (
          <AccountSummary
            userInitial={user.firstName.charAt(0)}
            userName={`${user.firstName} ${user.lastName}`}
            currentlySubscribed={user.currentlySubscribed}
            vipOptIn={user.vipOptIn}
            border={false}
          />
        )}
        <div className="close-icon-wrapper">
          <button
            aria-label="close-button"
            className="close-icon button-reset"
            onClick={closeMenu}
            type="button"
            id="close-button"
          >
            <Cross2Icon width={43} height={43} color="#F6F6F6" />
          </button>
        </div>
      </div>
      <div className="menu-body">
        <ul
          id={id}
          className="menu-list"
        >
          {items.map(menuItem => (
            <li
              key={parameterize(`player-menu-${menuItem.title}`)}
              className={`menu-item ${isActiveItem(activeItem, menuItem.url) ? ' active' : ''} ${makeClassName('menu-item', menuItem.title)}`}
            >
              {menuItem.title === 'Live TV' && isDesktop ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  onClick={handleLiveTVClick}
                  onKeyDown={handleLiveTVClick}
                  role="presentation"
                  className={`live-card ${showLiveTV ? 'active' : ''} ${makeClassName('menu-link', menuItem.title)}`}
                >{menuItem.title} <Chevron2Icon direction="down" />
                </a>
              ) : (
                // Render other menu items
                <a
                  href={getCrossDomainUrl({
                    path: menuItem.url,
                    subdomain: 'player',
                    hostname,
                  })}
                  className={`${makeClassName('menu-link', menuItem.title)}`}
                >
                  {menuItem.title}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
      {showLiveTV && <LiveCardOverlay groupToken={groupToken} renderCTVBanner={renderCTVBanner} />}
      <style jsx>{styles}</style>
    </div>
  )
}
PlayerMenu.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool,
  hostname: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  activeItem: PropTypes.string,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    signedIn: PropTypes.bool,
    vipOptIn: PropTypes.bool,
    currentlySubscribed: PropTypes.bool,
  }),
  closeMenu: PropTypes.func,
  groupToken: PropTypes.string.isRequired,
  renderCTVBanner: PropTypes.bool,
  isSearchMenuActive: PropTypes.bool,
  closeSearch: PropTypes.func,
  accountMenuActive: PropTypes.bool,
}
PlayerMenu.defaultProps = {
  id: '',
  isActive: false,
  items: [],
  activeItem: '',
  user: null,
  closeMenu: () => {},
  renderCTVBanner: false,
  isSearchMenuActive: false,
  closeSearch: () => {},
  accountMenuActive: false,
}
export default PlayerMenu
